import React, { useState, useEffect } from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';

// Set the size of the map
const containerStyle = {
  width: '100%',
  height: '400px'
};

const locations = [
  { 
    lat: 30.40914745313243, 
    lng: -97.68018831241405, 
    title: 'Alpha Dessert Juice Cafe',
    address: '1212 W Parmer Ln unit A, Austin, TX 78727' 
  },
  { 
    lat: 30.497229755823042, 
    lng: -97.6578393410473, 
    title: 'IndoPak Halal Supermarket',
    address: '1500 A W Grimes Blvd #120, Round Rock, TX 78664'
  },
  { 
    lat: 30.38258273467032, 
    lng: -97.6851490665145, 
    title: 'International Foods Market',
    address: '11331 N Lamar Blvd, Austin, TX 78753'
  },
  { 
    lat: 30.36705435688831, 
    lng: -97.69674989815583, 
    title: 'World Food and Halal Market',
    address: '9616 N Lamar Blvd #125, Austin, TX 78753'
  },
  { 
    lat: 30.531992853349866, 
    lng: -97.77993393496962, 
    title: 'Quality Halal',
    address: '12920 W Parmer Ln UNIT 106, Cedar Park, TX 78613'
  },
  {
    lat: 29.6189848135584, 
    lng: -97.91999263256837, 
    title: 'Brother Nooruddin',
    address: '2035 Ilka Switch, Seguin, TX 78155'
  }
  ,
  {
    lat: 29.90159489004534,
    lng: -97.78079856139536,
    title: 'Nicolas',
    address: '2316 Misty Ln, Maxwell, TX 78656'
  },
  {
    lat: 30.71034802795667,
    lng: -97.94701737485886,
    title: 'Brother Khalid',
    address: '401 Phillip Ln, Liberty Hill, TX 78642'
  },
  {
    lat: 29.798001846202435,
    lng: -96.22936815150177,
    title: 'Brother Ali’s Farm',
    address: '6707 Brockstein Rd, Sealy, TX 77474'

  }, 
  {
    lat: 30.724869544316913,
    lng:  -98.04400261646526,
    title: 'Gerald Moffet',
    address: ' FM 1174, Bertram, TX 78605'
  },
  {
    lat: 29.950608531748852, 
    lng: -97.3851352037209,
    title: 'Mr. Wes / Jimmy',
    address: 'Signup Form: https://tinyurl.com/2djfdvnj'
  },

];

const GoogleMapComponent = () => {
  const [mapRef, setMapRef] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);

  // Fit map bounds to show all markers
  useEffect(() => {
    if (mapRef) {
      const bounds = new window.google.maps.LatLngBounds();
      locations.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
      mapRef.fitBounds(bounds);
    }
  }, [mapRef]);

  const center = { lat: 30.4, lng: -97.7 };

  // Function to create a Google Maps directions link for the address
  const getDirectionsUrl = (address) => {
    return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
  };

  return (
    <LoadScript googleMapsApiKey="AIzaSyA-ynSfE2NivtAdeXTsAsLBcxIvOabdzLU">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={13}
        onLoad={map => setMapRef(map)}
      >
        {locations.map((location, index) => (
          <Marker
            key={index}
            position={{ lat: location.lat, lng: location.lng }}
            title={location.title} 
            onClick={() => setSelectedLocation(location)}
          />
        ))}

        {selectedLocation && (
          <InfoWindow
            position={{ lat: selectedLocation.lat, lng: selectedLocation.lng }}
            onCloseClick={() => setSelectedLocation(null)}
          >
            <div>
              <h4>{selectedLocation.title}</h4>
              <p>{selectedLocation.address}</p>
              <a 
                href={getDirectionsUrl(selectedLocation.address)} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Get Directions
              </a>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default GoogleMapComponent;
